import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable, tap } from 'rxjs';
import { ProjectsService } from '@front-end/core/services';

@Injectable({
  providedIn: 'root',
})
export class BuyerGuard implements CanActivate {
  constructor(
    private projectsService: ProjectsService,
    private router: Router
  ) {}

  canActivate(): Observable<boolean> {
    return this.projectsService.isBuyerInSomeProject().pipe(
      tap((isBuyer) => {
        if (!isBuyer) {
          this.router.navigate(['/home']);
        }
      })
    );
  }
}
